import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import TopicListItem from './TopicListItem';
import paths from '../../paths';
import { getNoun } from '../../utils/helpers';

export default class ForumCategoryItem extends Component {
  static propTypes = {
    category: PropTypes.shape({
      id: PropTypes.number.isRequired,
      alias: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      isOpen: PropTypes.bool.isRequired,
      totalComments: PropTypes.number.isRequired,
      totalTopics: PropTypes.number.isRequired,
      topics: PropTypes.array.isRequired,
    }).isRequired,
  };

  constructor(props) {
    super(props);

    this.topicsToRender = 3;

    this.state = {};
  }

  render() {
    const {
      id, alias, title, isOpen, totalComments, totalTopics, topics,
    } = this.props.category;
    return (
      <div className="section-box themes-list">
        <div className="themes-list__row themes-list__header">
          <div className="themes-list__item themes-list__item--icon">
            <i
              className={classNames('themes-list__icon', { 'themes-list__icon--locked': !isOpen })}
            />
          </div>
          <div className="themes-list__item themes-list__item--title">
            <Link to={`${paths.advocates.forumCategories}/${alias}`} className="themes-list__section-title">{title}</Link>
          </div>
          <div className="themes-list__item themes-list__item--messages-counter -mobile-hide">
            <span className="count">{totalComments}</span>
            {` ${getNoun(totalComments, 'сообщение', 'сообщения', 'сообщений')}`}
          </div>
          <div className="themes-list__item themes-list__item--themes-count -mobile-hide">
            <span className="count">{totalTopics}</span>
            {` ${getNoun(totalTopics, 'тема', 'темы', 'тем')}`}
          </div>
          <div className="themes-list__item themes-list__item--button -mobile-hide">
            {isOpen && <Link to={`${paths.advocates.forumNewTopic}/${alias}`} className="btn themes-list__button" onClick={this.handleCreateTopic}>Создать тему</Link>}
          </div>
        </div>
        {topics ? topics.map(topic => <TopicListItem key={topic.id} topic={topic} />) : ''}
        <div className="themes-list__button-row">
          {totalTopics > this.topicsToRender && (
            <Link to={`${paths.advocates.forumCategories}/${alias}`} className="themes-list__button-load-themes">
              {`Посмотреть еще ${totalTopics - this.topicsToRender} ${getNoun(totalTopics - this.topicsToRender, 'тема', 'темы', 'тем')}`}
            </Link>
          )}
          {isOpen && <Link to={`/forum/new-topic/${alias}`} className="btn themes-list__button  -mobile-show">Создать тему</Link>}
        </div>
      </div>
    );
  }
}
